import Axios from "axios";
import {
  SET_PREVIOUS_EMPLOYMENT_INFO_LIST,
  UNSET_PREVIOUS_EMPLOYMENT_INFO_LIST,
  SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS,
  UNSET_PREVIOUS_EMPLOYMENT_INFO_DETAILS,
} from '@/store/mutation-types';
import {
  getPreviousEmploymentInfoList,
  getPreviousEmploymentInfoById,
  getPreviousEmploymentInfoByEmployee,
  saveUpdatePreviousEmploymentInfo,
  saveEmployeePreviousEmploymentInfo,
  updatePreviousEmploymentInfo,
  deletePreviousEmploymentInfo,
} from '@/store/api';

const state = {
  previousEmploymentInfoList: [],
  currentPreviousEmploymentInfo: null,
  loading: false,
  error: null
}

const getters = {
  getPreviousEmploymentInfoList: (state) => state.previousEmploymentInfoList,
  getCurrentPreviousEmploymentInfo: (state) => state.currentPreviousEmploymentInfo,
  isLoading: (state) => state.loading,
  getError: (state) => state.error
}

const actions = {
  async fetchPreviousEmploymentInfoByEmployee({ commit }, employeeId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await Axios.get(getPreviousEmploymentInfoByEmployee(employeeId))
      if (response.data.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_LIST', response.data.data)
      } else {
        commit('SET_ERROR', response.data.message)
      }
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async saveEmployeePreviousEmploymentInfo({ commit }, { employeeId, employmentData }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await Axios.post(saveEmployeePreviousEmploymentInfo, {
        employee_id: employeeId,
        employment_data: employmentData
      })
      if (response.data.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_LIST', response.data.data)
        return response.data
      } else {
        commit('SET_ERROR', response.data.message)
        throw new Error(response.data.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchPreviousEmploymentInfoById({ commit }, id) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await Axios.get(getPreviousEmploymentInfoById(id))
      if (response.data.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS', response.data.data)
      } else {
        commit('SET_ERROR', response.data.message)
      }
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async savePreviousEmploymentInfo({ commit }, employmentData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await Axios.post(saveUpdatePreviousEmploymentInfo, employmentData)
      if (response.data.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS', response.data.data)
        return response.data
      } else {
        commit('SET_ERROR', response.data.message)
        throw new Error(response.data.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updatePreviousEmploymentInfo({ commit }, { id, employmentData }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await Axios.put(updatePreviousEmploymentInfo(id), employmentData)
      if (response.data.success) {
        commit('SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS', response.data.data)
        return response.data
      } else {
        commit('SET_ERROR', response.data.message)
        throw new Error(response.data.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deletePreviousEmploymentInfo({ commit }, id) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await Axios.delete(deletePreviousEmploymentInfo(id))
      if (response.data.success) {
        return response.data
      } else {
        commit('SET_ERROR', response.data.message)
        throw new Error(response.data.message)
      }
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  clearError({ commit }) {
    commit('SET_ERROR', null)
  },

  clearCurrentPreviousEmploymentInfo({ commit }) {
    commit('UNSET_PREVIOUS_EMPLOYMENT_INFO_DETAILS')
  }
}

const mutations = {
  [SET_PREVIOUS_EMPLOYMENT_INFO_LIST](state, list) {
    state.previousEmploymentInfoList = list
  },
  [SET_PREVIOUS_EMPLOYMENT_INFO_DETAILS](state, info) {
    state.currentPreviousEmploymentInfo = info
  },
  [UNSET_PREVIOUS_EMPLOYMENT_INFO_LIST](state) {
    state.previousEmploymentInfoList = []
  },
  [UNSET_PREVIOUS_EMPLOYMENT_INFO_DETAILS](state) {
    state.currentPreviousEmploymentInfo = null
  },
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
